<template>
  <div>
    <sidebar :sideBarData="sidebarData" />
    <img class="header" v-lazy="require('@/img/izixun/classOne/header.png')" />
    <div id="classOneId1">
      <pageTitle title="为什么选择学而思1对1" subTitle="个性化1对1辅导，探索学习问题" />
      <ul class="part1">
        <li>
          <h4><img v-lazy="require('@/img/izixun/classOne/part1-icon1.png')" />线上线下无缝链接</h4>
          <p>
            <span class="icon iconfont icon-solid-half-arrow" />
            <span>01</span>
            师资、教研、讲义、教学内容课后辅导，做到线上线下一致孩子线上线下都能学，课程无缝切换，形式更灵活。
          </p>
        </li>
        <li>
          <h4><img v-lazy="require('@/img/izixun/classOne/part1-icon2.png')" />透明课堂可监控</h4>
          <p>
            <span class="icon iconfont icon-solid-half-arrow" />
            <span>02</span>
            家长可在教室内或者通过手机App实时查看上课情况。了解教师授课与学生听课情况，听课组教师随机抽查课堂情况。
          </p>
        </li>
        <li>
          <h4><img v-lazy="require('@/img/izixun/classOne/part1-icon3.png')" />个性化针对学习</h4>
          <p>
            <span class="icon iconfont icon-solid-half-arrow" />
            <span>03</span>
            授课内容针对孩子存在的障碍专项讲解，课上高频互动，关注每个孩子的学习吸收情况。
          </p>
        </li>
        <li>
          <h4><img v-lazy="require('@/img/izixun/classOne/part1-icon4.png')" />精选本地好老师</h4>
          <p>
            <span class="icon iconfont icon-solid-half-arrow" />
            <span>04</span>
            教师均为本地线下师资，更了解本地学情、知识点、校情，辅导更有针对性，更贴近本地学校要求。
          </p>
        </li>
      </ul>
    </div>
    <div id="classOneId2" class="part2">
      <pageTitle title="完善的课程体系" subTitle="本地教研团队研发课程 更适合本地孩子" />
      <div v-if="classList" class="part2-cont">
        <div class="part2-left">
          <p @click="schoolActive = index; gradeActive = 0" :class="{'part2-left-active': schoolActive === index}" v-for="(item, index) in classList" :key="index">
            {{item.label}}
            <span class="icon iconfont icon-sanjiaoxing" />
          </p>
        </div>
        <div class="part2-right">
          <div class="part2-right-title">
            <p @click="gradeActive = index" :class="{'part2-right-title-active': gradeActive === index}" v-for="(item, index) in schoolData" :key="index">{{item.label}}</p>
          </div>
          <div class="part2-right-info">
            <p v-for="(item, index) in gradeData" :key="index"><span>{{item.label}}</span>{{item.text}}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="classOneId3">
      <pageTitle title="1对1定制课程方案" subTitle="结合课程需要，定制学习方案" />
      <ul class="part3-cont">
        <li>
          <h4>1对1精品长期课</h4>
          <span class="ornament"></span>
          <p>明确学习目标，制定长期方案，按阶段推进学习进度，过程监督与检测</p>
          <div><img v-lazy="require('@/img/izixun/classOne/part3-1.png')" /></div>
        </li>
        <li>
          <h4>1对1短期模块课</h4>
          <span class="ornament"></span>
          <p>知识模块查缺补漏，碎片时间高效利用，重点内容针对性讲解</p>
          <img v-lazy="require('@/img/izixun/classOne/part3-2.png')" />
        </li>
        <li>
          <h4>毕业班1对1考经课</h4>
          <span class="ornament"></span>
          <p>总结考试经验、梳理答题思路，归纳常考题型，为提高学习效率提供助力</p>
          <img v-lazy="require('@/img/izixun/classOne/part3-3.png')" />
        </li>
        <li>
          <h4>更多定制化课程</h4>
          <span class="ornament"></span>
          <p>闲时充分利用时间，培养学习习惯，教师个性化辅导，难题逐一细致讲解</p>
          <img v-lazy="require('@/img/izixun/classOne/part3-4.png')" />
        </li>
      </ul>
    </div>
    <div id="classOneId4" class="class-process">
      <pageTitle title="学而思1对1报名流程" subTitle="规范的报名流程，保证家长和学生权益" />
      <div class="class-process-cont">
        <img v-lazy="require('@/img/izixun/classOne/part4.png')" />
        <p class="class-process-cont-info" style="top: 110px;left: 50px;">专属学习顾问<br />了解学生情况</p>
        <p class="class-process-cont-info" style="top: 110px;left: 345px;">沟通确定学习<br />内容或辅导方向</p>
        <p class="class-process-cont-info" style="top: 110px;left: 643px;">双方确定上课<br />时间、形式、校区</p>
        <p class="class-process-cont-info" style="top: 110px;left: 938px;">下订单后完成报名交费</p>
        <p class="class-process-cont-info" style="top: 321px;left: 938px;">学习顾问与排课组<br />匹配任课教师</p>
        <p class="class-process-cont-info" style="top: 321px;left: 643px;">任课教师与家长<br />和学生课前沟通</p>
        <p class="class-process-cont-info" style="top: 321px;left: 345px;">正式开课</p>
        <p class="class-process-cont-info" style="top: 321px;left: 50px;">直至课程结束</p>
        <p class="class-process-cont-tip" style="left: 345px;"><span/>无条件更换教师<br />或退还余费</p>
        <p class="class-process-cont-tip" style="left: 643px;"><span/>无条件更换教师<br />或全额退费</p>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "./components/pageTitle.vue";
import sidebar from "./components/sidebar.vue";
import { classList } from "./common/classList.js"
import Vue from 'vue';
import { Lazyload } from 'mint-ui';
Vue.use(Lazyload);
export default {
  name: "classOne",
  components: {
    pageTitle,
    sidebar
  },
  data() {
    return {
      classList: null,
      sidebarData: [
        {
          id: 'classOneId1',
          value: '学而思1对1'
        },
        {
          id: 'classOneId2',
          value: '课程体系'
        },
        {
          id: 'classOneId3',
          value: '定制课程'
        },
        {
          id: 'classOneId4',
          value: '报名流程'
        }
      ],
      schoolActive: 0,
      gradeActive: 0
    };
  },
  computed: {
    schoolData() {
      return this.classList[this.schoolActive].value;
    },
    gradeData() {
      return this.schoolData[this.gradeActive].value;
    }
  },
  mounted() {
    this.classList = classList
  }
};
</script>
<style lang="scss" scoped>
.part1 {
  display: flex;
  justify-content: center;
  padding-bottom: 80px;
  li {
    width: 280px;
    margin-right: 26px;
    height: 387px;
    background: linear-gradient(180deg, #FFEAD8 0%, #FFC898 100%);
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px 8px 8px 0px;
    position: relative;
    &:hover {
      background: #CD0014;
      h4 {
        color: #fff;
      }
      span {
        color: #CD0014!important;
      }
    }
    h4 {
      font-size: 22px;
      font-weight: 500;
      color: #905008;
      line-height: 30px;
      padding-top: 28px;
      img {
        width: 30px;
        height: 30px;
        margin: 0 15px;
      }
    }
    p {
      width: 220px;
      height: 264px;
      background: #FFFFFF;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.06);
      border-radius: 0px 32px 0px 0px;
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 42px 20px 0 27px;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      line-height: 30px;
      span:first-child {
        position: absolute;
        font-size: 12px;
        color: #FFCB9D;
        left: 27px;
        bottom: 35px;
        transform: scale(0.6, 0.6);
      }
      span:nth-child(2) {
        position: absolute;
        font-size: 40px;
        font-weight: bold;
        color: #FFCB9D;
        line-height: 47px;
        right: 27px;
        bottom: 32px;
      }
    }
  }
  li:nth-child(1):hover img {
    content: url('../../img/izixun/classOne/part1-icon-hover1.png');
  }
  li:nth-child(2):hover img {
    content: url('../../img/izixun/classOne/part1-icon-hover2.png');
  }
  li:nth-child(3):hover img {
    content: url('../../img/izixun/classOne/part1-icon-hover3.png');
  }
  li:last-child {
    margin-right: 0;
    &:hover img {
      content: url('../../img/izixun/classOne/part1-icon-hover4.png');
    }
  }
}
.part2 {
  padding-bottom: 83px;
  background: url('../../img/izixun/classOne/part2.png') center 0 no-repeat;
  background-size: auto 1200px;
  /deep/ .page_title {
    span, p {
      color: #fff!important;
    }
  }
  .part2-cont {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
  }
  .part2-left {
    float: left;
    width: 220px;
    p {
      height: 100px;
      line-height: 100px;
      text-align: center;
      background-color: #CD0014;
      font-size: 26px;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      display: flex;
      justify-content: center;
    }
    span {
      font-size: 12px;
      transform: scale(0.9, 0.9);
      margin-left: 20px;
    }
    .part2-left-active {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  .part2-right {
    float: left;
    width: 935px;
    padding: 50px 0 47px 45px;
    background-color: rgba(0, 0, 0, 0.2);
    .part2-right-title {
      overflow: hidden;
      p {
        float: left;
        width: 140px;
        height: 50px;
        line-height: 50px;
        background: #FFFFFF;
        border-radius: 8px 8px 0px 0px;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: #222222;
        margin-right: 10px;
        cursor: pointer;
      }
      p:last-child {
        margin-right: 0;
      }
      .part2-right-title-active {
        background: linear-gradient(90deg, #FFEAD8 0%, #FFC898 100%);
        color: #CD0014;
      }
    }
    
    .part2-right-info {
      width: 800px;
      border-top: 2px solid #CD0014;
      background: #FFFFFF;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.06);
      padding: 40px 45px;
      p {
        height: 44px;
        line-height: 44px;
        background: linear-gradient(270deg, rgba(248, 249, 251, 0.2) 0%, #F8F9FB 100%);
        margin-bottom: 20px;
        position: relative;
        font-size: 16px;
        font-weight: 300;
        color: #666666;
        span {
          display: inline-block;
          width: 94px;
          background: #EDF0F5;
          text-align: center;
          margin-right: 27px;
          position: relative;
          font-size: 18px;
          color: #222222;
          &::after {
            content: " ";
            position: absolute;
            right: -4px;
            top: 18px;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 4px solid #EDF0F5;
          }
        }
        &:hover {
          span {
            background-color: #CD0014;
            color: #fff;
            &::after {
              border-left-color: #CD0014;
            }
          }
        }
      }
      p:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.part3-cont {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 40px;
  li {
    float: left;
    width: 542px;
    height: 160px;
    background: #F8F9FB;
    border-radius: 8px;
    margin: 0 40px 40px 0;
    position: relative;
    padding: 40px 0 0 38px;
    h4 {
      font-size: 22px;
      font-weight: 500;
      color: #222222;
      line-height: 30px;
    }
    p {
      width: 360px;
      font-size: 16px;
      font-weight: 300;
      color: #666666;
      line-height: 22px;
    }
    img {
      border-radius: 50px;
      position: absolute;
      right: 48px;
      top: 50px;
      width: 100px;
      height: 100px;
      background: #CD0014;
    }
    .ornament {
      margin: 20px 0;
    }
    &:hover {
      background-color: #CD0014;
      img {
        background-color: #fff;
      }
      h4, p {
        color: #fff;
      }
      .ornament {
        background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
      }
    }
  }
  li:nth-child(2n) {
    margin-right: 0;
  }
}
// .part4 {
//   background: #F8F9FB;
//   position: relative;
//   padding-bottom: 174px;
//   &::after {
//     content: " ";
//     width: 100%;
//     height: 174px;
//     background: #CD0014;
//     position: absolute;
//     left: 0;
//     bottom: 0;
//     z-index: 1;
//   }
//   .part4-cont {
//     width: 1050px;
//     margin: 0 auto;
//     padding: 0 55px 98px 95px;
//     position: relative;
//     img {
//       width: 100%;
//     }
//     .part4-cont-info {
//       position: absolute;
//       font-size: 16px;
//       font-weight: 400;
//       color: #222222;
//       line-height: 22px;
//       width: 180px;
//       text-align: center;
//     }
//     .part4-cont-tip {
//       position: absolute;
//       width: 160px;
//       height: 52px;
//       z-index: 10;
//       border: 1px dotted #FFFFFF;
//       font-size: 16px;
//       font-weight: 400;
//       color: #FFFFFF;
//       line-height: 22px;
//       text-align: center;
//       bottom: -94px;
//       padding-top: 8px;
//       &::before {
//         content: " ";
//         position: absolute;
//         left: 73px;
//         top: -33px;
//         border-left:8px solid transparent;
//         border-right:8px solid transparent;
//         border-top:10px solid #fff;
//       }
//       span {
//         position: absolute;
//         left: 73px;
//         top: -43px;
//         border-left:8px solid transparent;
//         border-right:8px solid transparent;
//         border-top:10px solid #CD0014;
//         &::after {
//           content: " ";
//           position: absolute;
//           left: -0.5px;
//           top: -27px;
//           height: 17px;
//           border-left: 1px dotted #CD0014;
//         }
//       }
//     }
//   }
// }
</style>
